import PropTypes from "prop-types";
import { Card, CardBody, CardHeader, Table } from "reactstrap";

import { Badges, H3, H4, MUIIcons, ToolTip } from "../../AbstractElements";
import CardHeaderDropDown from "../../CommonElements/CommonCardHeader/CardHeaderDropDown";
import "./style.scss";
import { HRDocument } from "../../utils/Constant";
import {
  extractFileName,
  getEllipsedFileName,
  hrDocumentHeader,
  sanitizeString,
} from "../../utils/helper/helper";
import useIsMobile from "../../utils/helper/responsive";

const HRDocumentTable = ({
  data,
  title,
  setSelectedAssessment,
  onClickItem,
  isEdit = true,
}) => {
  const isMobile = useIsMobile();

  return (
    <Card>
      <CardHeader>
        <H4>{title}</H4>
      </CardHeader>
      <CardBody className="pt-0 projects px-0">
        <div className="dataTables_wrapper">
          <div
            className={
              isMobile ? "table-responsive theme-scrollbar" : "theme-scrollbar"
            }
          >
            <Table
              className="table display dataTable no-footer"
              id="selling-product"
            >
              <thead className="light-background">
                <tr>
                  {hrDocumentHeader.map((header, index) => (
                    <th className=".b-b-secondary" key={index}>
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data?.map((item: any, i) => {
                  return (
                    <tr key={i}>
                      <td>
                        {item?.learnerDocs?.map((doc, docIndex) => {
                          const uniqueId = `${i}-${docIndex}${i}`;
                          return (
                            <H3 className="mt-2" key={docIndex}>
                              <Badges color="light text-dark">
                                <div className="d-flex align-items-center mb-1">
                                  <MUIIcons
                                    size={24}
                                    iconName="InsertDriveFileOutlined"
                                  />
                                  <span
                                    className="mt-1 mx-1"
                                    id={sanitizeString(
                                      `tooltip-course1-name-${uniqueId}`
                                    )}
                                  >
                                    {getEllipsedFileName(
                                      extractFileName(doc),
                                      50
                                    )}
                                  </span>
                                  <ToolTip
                                    placement="top"
                                    target={sanitizeString(
                                      `tooltip-course1-name-${uniqueId}`
                                    )}
                                  >
                                    {extractFileName(doc)}
                                  </ToolTip>
                                </div>
                              </Badges>
                            </H3>
                          );
                        })}
                      </td>
                      <td onClick={() => setSelectedAssessment(i)}>
                        <CardHeaderDropDown
                          mainTitle={
                            isEdit || (title === HRDocument && !isEdit)
                          }
                          firstItem={isEdit ? "Edit" : ""}
                          secondItem={isEdit ? "Delete" : ""}
                          thirdItem={
                            title === HRDocument || !isEdit ? "Download" : ""
                          }
                          onClickItem={value => onClickItem(value, title)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

HRDocumentTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string,
  setSelectedAssessment: PropTypes.func.isRequired,
  onClickItem: PropTypes.func.isRequired,
  isEdit: PropTypes.bool,
};

export default HRDocumentTable;
